import { createAction } from "@reduxjs/toolkit";

// Central lifecycle event for switching active project in the UI.
export const projectSwitched = createAction<number>("project/projectSwitched");
